<template>
  
<div class="pe_pausemodal">

    <div class="pe_pausemodal_sub">
          <div class="pe_row pe_logo">
            <component 
                v-bind:is="logoComponentAni" 
                class="pe_logo"
              /> 
          </div>     
            <div class="pe_row">
                <h2 class="pe_pausemodal_h2">Puzzle Paused</h2>
            </div>
            <div class="pe_row"><span style="vertical-align: middle;">Paused at</span> <span style="vertical-align: middle;"><stopwatch></stopwatch></span></div>
            <div class="pe_row">Click the button below when you are ready to play</div>
            <div class="pe_row">
              <button @click="resumePuzzle" :class="['pe_pausemodal_btn', gameClasses]">Resume Puzzle</button>
              <!--<span @click="resumePuzzle"  :class="['pe_pausemodal_resume', gameClasses]">RESUME PUZZLE</span>-->
            </div>
    

    </div>


</div>

</template>

<script>

import { mapActions, mapState } from 'vuex'

import Modal from './Modal'
 
import Cross from '@puzzleapps/shared/src/components/ui/icons/Cross'
import sudoku from '@puzzleapps/shared/src/components/ui/logos/sudoku_animated' 
import Addoku from '@puzzleapps/shared/src/components/ui/logos/Addoku' 
import wordsearch from '@puzzleapps/shared/src/components/ui/logos/Wordsearch_animated' 
import codecracker from '@puzzleapps/shared/src/components/ui/logos/Codecracker_animated' 
import crossword from '@puzzleapps/shared/src/components/ui/logos/Crossword_animated' 
import trivia from '@puzzleapps/shared/src/components/ui/logos/Trivia_animated' 
import stopwatch from '@puzzleapps/shared/src/components/ui/StopWatch' 


export default {  

  components: {

      Addoku,
      sudoku,
      wordsearch,
      crossword,
      codecracker,
      trivia,
    Modal,
    'close-icon': Cross,
    stopwatch,
  },

  data () {
    return {
      modalIsOpen: false,
      clientId: null,
      singleRouterPath: null,
      logoComponentAni: null,
    }
  },

  mounted() {
    this.clientId = window.PE_CLIENTAPP_ID
    this.logoComponentAni = this.setLogo
  },

  methods: {

    ...mapActions({
      setIsPlaying: 'game/setIsPlaying',
      goToPuzzleRoute: 'game/goToPuzzleRoute',
      setIsPaused: 'game/setIsPaused',
    }), 



    onModalClose() {
      this.setIsPlaying(true)
      this.setIsPaused(false)
    },

    resumePuzzle(){
      this.setIsPlaying(true)
      this.setIsPaused(false)
    },
    setLogo(){
      this.logoComponentAni = this.gameType
    }

  },

  computed: {
    ...mapState({

      isPlaying: state => state.game.isPlaying,
      titleHtml: state => state.game.titleHtml,
      gameType: state => state.game.type,
      isPaused: state => state.game.isPaused,
    }),

    gameClasses() {  
        let classes = {
          [this.gameType] : true,

        }
        return classes
    },

    isHome() {
      return this.$route.name === 'Home'
    }
  }

}
</script>

<style scoped lang="scss">

#puzzleapp {

  .slide-leave-active,
  .slide-enter-active {
    transition: 0.3s;
  }
  .slide-enter {
    transform: translate(100%, 0);
  }
  .slide-leave-to {
    transform: translate(-100%, 0);
  }

  .pe_pausemodal {

    position: absolute;
    width: 100%;
    max-width: 100%;
    //top: 1%;
    //left: 1%;
    right: 0;
    top:0;
    height: 100%;
    background: var(--modal-background);
    color: var(--default-font-color);
    z-index: 30;
    // overflow: auto;
    
  }

  .pe_pausemodal_sub{
       z-index: 50;
    // background: rgba(0,0,0,0.2);
    background: #222222a8;//var(--secondary-background-color);
    width: 100%;
      height: 100%;
      //border: 2px black groove;
      //border-radius:10px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #fff; //var(--default-font-color);
  }

  .pe_pausemodal_h2{
    font-size: 2.2em!important;
    color: #fff!important;
  }

  .pe_row{
    margin-bottom: 10px;
    padding: 0 10px;

    &.pe_logo{
      width:70px;
    }
  }
  .pe_pausemodal_btn{


    align-items: center;
    
    border: 2px solid  rgba(0, 0, 0, 0.13);
    border-radius: 4px;
    bottom: 0px;
    box-sizing: border-box;
    color:  #ffffff;
    cursor: pointer;
    display: inline-flex;
    font-family: Poppins, Helvetica, Arial, sans-serif;
    font-size: 19.2px;
    font-weight: 600;
    justify-content: center;
    left: 0px;
    letter-spacing: 1px;
    line-height: 1;
    margin: 0.8em 0;
    padding: 0.9em;
    position: relative;
    right: 0px;
    text-decoration: none;
    top: 0px;
    transition: all 0.2s ease 0s;
    width: 100%;
    &.crossword{
      background:  var(--crossword-menu-btn-background) none repeat scroll 0% 0% / auto padding-box border-box;
      &:hover{
        background: var(--crossword-menu-btn-hover);
        color: var(--crossword-menu-btn-background);
        border-color: var(--crossword-menu-btn-background);
      }
    }
    &.sudoku{
      background:  var(--sudoku-menu-btn-hover) none repeat scroll 0% 0% / auto padding-box border-box;
      color: #000;
      &:hover{
        background: var(--sudoku-menu-btn-background);
      } 
    }

    &.codecracker{
      background:  var(--codecracker-menu-btn-background) none repeat scroll 0% 0% / auto padding-box border-box;
      &:hover{
        background: var(--codecracker-menu-btn-hover);
      }
    }

    &.wordsearch{
      background:  var(--wordsearch-menu-btn-background) none repeat scroll 0% 0% / auto padding-box border-box;
      &:hover{
        background: var(--wordsearch-menu-btn-hover);
      }
    }
    &.trivia{
      background:  var(--trivia-menu-btn-background) none repeat scroll 0% 0% / auto padding-box border-box;
      &:hover{
        background: var(--trivia-menu-btn-hover);
      }
    }

  }
  .pe_pausemodal_resume{
    margin: 10px 10px 10px 10px;
    cursor: pointer;

    font-family: 'poppins';
    text-transform: capitalize;
    letter-spacing: 2px;
    border-bottom: 1px solid white;
    font-weight: 400;
    &.sudoku{
      color: var(--sudoku-menu-btn-hover);
      border-bottom: 1px solid var(--sudoku-menu-btn-hover);
        &:hover{
          color: var(--sudoku-menu-light);
          border-bottom: 1px solid var(--sudoku-menu-light);
        }
    }
    &.crossword{
      color: var(--crossword-menu-btn-hover);
      border-bottom: 1px solid var(--crossword-menu-btn-hover);
        &:hover{
          color: var(--crossword-menu-light);
          border-bottom: 1px solid var(--crossword-menu-light);
        }
    }
    &.codecracker{
      color: var(--codecracker-menu-btn-hover);
      border-bottom: 1px solid var(--codecracker-menu-btn-hover);
        &:hover{
          color: var(--codecracker-menu-light);
          border-bottom: 1px solid var(--codecracker-menu-light);
        }
    }
    &.wordsearch{
      color: var(--wordsearch-menu-btn-hover);
      border-bottom: 1px solid var(--wordsearch-menu-btn-hover);
        &:hover{
          color: var(--wordsearch-menu-light);
          border-bottom: 1px solid var(--wordsearch-menu-light);
        }
    }

    &.trivia{
      color: var(--trivia-menu-btn-hover);
      border-bottom: 1px solid var(--trivia-menu-btn-hover);
        &:hover{
          color: var(--trivia-menu-light);
          border-bottom: 1px solid var(--trivia-menu-light);
        }
    }
  }


  


}


</style>